import type { ResumeData } from "@reactive-resume/schema";

import type { DetectedSection } from "./types";

export const getDetectedSections = (data: ResumeData): DetectedSection[] => {
  const items = (key: keyof ResumeData["sections"]) => {
    const section = data.sections[key] as { items?: unknown[] };
    return section.items ?? [];
  };

  const skillCount = items("skills").reduce<number>((total, item) => {
    const keywords = (item as { keywords?: unknown[] }).keywords;
    return total + (Array.isArray(keywords) ? keywords.length : 0);
  }, 0);

  const sections: DetectedSection[] = [
    {
      key: "basics",
      label: "Coordonnées",
      description: "Nom, e-mail et téléphone",
      count: [data.basics.name, data.basics.email, data.basics.phone].filter(Boolean).length,
    },
    {
      key: "summary",
      label: "Profil professionnel",
      description: "Résumé détecté",
      count: data.sections.summary.content ? 1 : 0,
    },
    {
      key: "experience",
      label: "Expériences",
      description: "expérience(s) détectée(s)",
      count: items("experience").length,
    },
    {
      key: "education",
      label: "Formations",
      description: "formation(s) détectée(s)",
      count: items("education").length,
    },
    {
      key: "skills",
      label: "Compétences",
      description: "compétence(s) détectée(s)",
      count: skillCount || items("skills").length,
    },
    {
      key: "languages",
      label: "Langues",
      description: "langue(s) détectée(s)",
      count: items("languages").length,
    },
  ];

  return sections.filter((section) => section.count > 0);
};
